
    <router-outlet *ngIf="!auth && defaultLangsLoaded"></router-outlet>
    <router-outlet *ngIf="auth"></router-outlet>
